import { useEffect, useState } from "react";

interface Props {
  onDone: () => void;
}

const LINES = [
  "在 30+ 海域里挑了一会儿…",
  "你这种类型的潜水员，去这里最合适……",
  "（结果即将揭晓）",
];

export function Loading({ onDone }: Props) {
  const [i, setI] = useState(0);
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    if (i < LINES.length - 1) {
      const fadeOut = setTimeout(() => setOpacity(0), 900);
      const swap = setTimeout(() => {
        setI(i + 1);
        setOpacity(1);
      }, 1200);
      return () => { clearTimeout(fadeOut); clearTimeout(swap); };
    } else {
      const finish = setTimeout(onDone, 1100);
      return () => clearTimeout(finish);
    }
  }, [i, onDone]);

  return (
    <section className="screen loading">
      <div className="loading-ring" />
      <div className="loading-line" style={{ opacity }}>{LINES[i]}</div>
    </section>
  );
}
